import React, { FC } from 'react';
import classNames from 'classnames';
import styles from './AsideContainer.module.scss';

export interface IAsideContainer {
  title?: string | JSX.Element;
  description?: string | JSX.Element;
  className?: string;
}

const AsideContainer: FC<IAsideContainer> = (props) => {
  const { title, description, children, className } = props;
  const rootClassName = classNames(styles.root, className);

  return (
    <div className={rootClassName}>
      {title && <h3 className={styles.title}>{title}</h3>}
      {description && <p className={styles.description}>{description}</p>}
      <div className={styles.widgets}>{children}</div>
    </div>
  );
};

export default AsideContainer;
